import { Card, Row, Col, Statistic, Typography } from "antd";
import { CheckCircleTwoTone, ClockCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

export default function PagosOverview({ pagos }) {
  const overview = pagos.reduce(
    (acc, pago) => {
      const amount = Number(pago.Monto) || 0;
      if (pago.Status === 2) {
        acc.done += amount;
      } else if (pago.Status === 1) {
        acc.pending += amount;
      } else if (pago.Status === 3) {
        acc.canceled += amount;
      }
      return acc;
    },
    { done: 0, pending: 0, canceled: 0 }
  );

  const valueStyle = { fontWeight: 500, fontSize: "1rem", textAlign: "right", color: "#444" };
  const labelStyle = { color: "#666", fontSize: "0.9rem" };
  const cardStyle = { borderRadius: 8, background: "#fff", border: "1px solid #f0f0f0" };

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }} justify="start">
      <Col xs={24} sm={8} style={{ maxWidth: 280, flex: "1 1 240px" }}>
        <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
          <Row align="middle" justify="space-between">
            <Col>
              <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 20 }} />
              <Typography.Text style={labelStyle}>&nbsp;Realizados</Typography.Text>
            </Col>
            <Col>
              <Typography.Text style={valueStyle}>${overview.done.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography.Text>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col xs={24} sm={8} style={{ maxWidth: 280, flex: "1 1 240px" }}>
        <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
          <Row align="middle" justify="space-between">
            <Col>
              <ClockCircleTwoTone twoToneColor="#faad14" style={{ fontSize: 20 }} />
              <Typography.Text style={labelStyle}>&nbsp;Pendientes</Typography.Text>
            </Col>
            <Col>
              <Typography.Text style={valueStyle}>${overview.pending.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography.Text>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col xs={24} sm={8} style={{ maxWidth: 280, flex: "1 1 240px" }}>
        <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
          <Row align="middle" justify="space-between">
            <Col>
              <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 20 }} />
              <Typography.Text style={labelStyle}>&nbsp;Cancelados</Typography.Text>
            </Col>
            <Col>
              <Typography.Text style={valueStyle}>${overview.canceled.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography.Text>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
